import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

export interface BreadcrumbItem {
    label: string;
    to?: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
    if (items.length <= 1) {
        return null;
    }

    return (
        <nav className="px-4 sm:px-6 py-1" aria-label="Breadcrumbs">
            <div className="container mx-auto">
                <ol className="flex items-center gap-1 text-sm text-muted-foreground">
                    {items.map((item, index) => (
                        <li key={index} className="flex items-center gap-1">
                            {index > 0 && <ChevronRight className="h-3 w-3 flex-shrink-0" />}
                            {item.to && index < items.length - 1 ? (
                                <Link
                                    to={item.to}
                                    className="hover:text-primary transition-colors font-medium min-h-[2.25rem] flex items-center px-1"
                                >
                                    {item.label}
                                </Link>
                            ) : (
                                <span className="text-foreground font-medium min-h-[2.25rem] flex items-center px-1">
                                    {item.label}
                                </span>
                            )}
                        </li>
                    ))}
                </ol>
            </div>
        </nav>
    );
}
